import React, { useEffect, useState } from "react";
import { GlobalRequest } from "../../../../../../../common/services/request";
import { Loader } from "../../../../../../../common/components/Loader/Loader";
import { HttpStatusCode } from "axios";
import { Tabs } from "antd";
import { PointingDetailsContext } from "../../../../../core/_context";
import { BagDetailsData } from "./BagDetailsData";
import { BagDetailsInfo } from "./BagDetailsInfo";

type PropsType = {
  initialValue?: any;
};

export const BagDetails = ({ initialValue }: PropsType) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [initialState, setInitialState] = useState<any>();

  /* const TAB_ITEMS = [
    {
      key: "DATA",
      label: "Données",
      children: <BagDetailsData />,
    },
    {
      key: "INFO",
      label: "Informations",
      children: <BagDetailsInfo />,
    },
  ]; */

  useEffect(() => {
    if (initialValue) {
      getBag(initialValue?.["@id"]);
    }
  }, [initialValue]);

  const getBag = async (url: string) => {
    try {
      setIsLoading(true);
      const res = await GlobalRequest.get(`${url}/controlled`);

      if (res?.status === HttpStatusCode.Ok) {
        setInitialState(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PointingDetailsContext.Provider
      value={{
        data: initialState,
      }}
    >
      <Loader isLoading={isLoading} />
      {/* <Tabs items={TAB_ITEMS} /> */}
      <BagDetailsData />
    </PointingDetailsContext.Provider>
  );
};
